// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { timesGroupSplitter } from '@tectonics/look-and-feel/commons/format-utils';

export function formatCashCode(cashCode: string): Node {
  const splitCashCode = timesGroupSplitter(4, cashCode);

  if(!splitCashCode){
    return null;
  }

  return(
    <CashCodeWrapper>
      {splitCashCode.map((element, index)=>{
        return <CashCodeSegment key={index}>{element}</CashCodeSegment>;
      })}
    </CashCodeWrapper>
  );
}

const CashCodeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const CashCodeSegment = styled.div`
  margin: 3px;
  background-color: #f8f8f9;
  color: #738093;
  border-radius: 5px;
  padding: 3px;
`;
